import {
    initialStreamedDataState,
    StreamedDataState,
} from 'streamsState/store/streamedData/StreamedDataState';
import {
    initialStreamStatusesState,
    StreamStatusesState,
} from 'streamsState/store/streamStatuses/StreamStatusesState';

export interface StreamsState {
    data: StreamedDataState;
    statuses: StreamStatusesState;
}

export const initialStreamState = {
    data: initialStreamedDataState,
    statuses: initialStreamStatusesState,
};
